export const eligibilityStrings = {
  strings: {
    en: {
      eligibility: 'Eligibility',
      eligibilitySectionDescription: 'There are two ways your household can qualify for CARE or FERA. Select the method you would like to use.',
      sourceOfIncome: 'Sources of Income',
      eligibilityOptionOne: 'Participate in public assistance program',
      eligibilityOptionTwo: 'Household Income as of Today',
      eligibilityOptionOneHint: 'Choose this method to show that you or someone in your home participates qualifying public assistance programs.',
      eligibilityOptionTwoHint: 'Choose this method if you wish to show that your household meets the income requirements. Even if you are receiving unemployment benefits, you may still qualify.',
      sourceOfIncomeDescription: 'Select all sources of your household income.',
      publicAssProgEligibility: 'Public Assistance Program Eligibility',
      publicAssProgEligibilityDiscription: 'Select all programs that members of your household participate in.',
      incomeEligibilityChart: 'Income Eligibility Chart',
      incomeEligibilityChartDescription: 'Continue if you qualify according to the chart below',
      anualHouseholdIncome: 'Annual Household Income',
      totalHouseholdIncome: 'Enter your total annual household income',
      dollorSymbol: '$',
      maximumHouseholdIncome: 'Maximum Household Income',
      totalCombinedAnnualIncome: 'Total Combined Annual Income',
      numberInHousehold: 'Number in Household',
      care: 'CARE',
      fera: 'FERA',
      empty: '',
      errorMessage: 'Please choose any of the options to verify and proceed.',
      stateProgramRecordError: 'Please select at least one option to proceed.',
      annualHouseholdIncomeErrorMsg: 'Please enter valid income.',
      recertifyOrEndEnroll: 'Recertify or End Enrollment',
      recertifyOrEndEnrollDiscription: 'Our records indicate you have previously enrolled. Please select what you like to do.'

    },
    zh: {
      eligibility: '合格',
      eligibilitySectionDescription: '您的家庭有两种方式可以获得CARE或FERA。 选择您要使用的方法。',
      sourceOfIncome: '收入來源',
      eligibilityOptionOne: '参加公共援助计划',
      eligibilityOptionTwo: '截至今日的家庭收入',
      eligibilityOptionOneHint: '如果您想證明自己或家中有人參加合乎條件的公共援助計劃，請選擇此方式。',
      eligibilityOptionTwoHint: '如果您想證明您的家庭符合收入條件，請選擇此方式。 即使您在領取失業福利，也有可能符合資格',
      sourceOfIncomeDescription: '請選擇您的家庭收入所有來源.',
      publicAssProgEligibility: '公共援助计划资格',
      publicAssProgEligibilityDiscription: '选择您家庭成员参与的所有计划',
      incomeEligibilityChart: '收入资格表',
      incomeEligibilityChartDescription: '如果您符合下表的资格，请继续',
      anualHouseholdIncome: '輸入您的家庭總年收入',
      totalHouseholdIncome: '家庭年收入e',
      dollorSymbol: '$',
      maximumHouseholdIncome: '最高家庭收入',
      totalCombinedAnnualIncome: '年度总收入总额',
      numberInHousehold: '家庭数量',
      care: 'CARE',
      fera: 'FERA',
      empty: '',
      errorMessage: '认证表格的右上角',
      stateProgramRecordError: '请选择至少一个选项继续',
      annualHouseholdIncomeErrorMsg: 'Please enter valid income',
      recertifyOrEndEnroll: '重新认证或结束注册',
      recertifyOrEndEnrollDiscription: '我们的记录显示您之前已注册。 请选择您想要做的事情'
    },
    es: {
      eligibility: 'Elegibilidad',
      eligibilitySectionDescription: 'Tu hogar puede calificar para CARE o FERA de dos maneras diferentes. Selecciona el método que deseas utilizar.',
      sourceOfIncome: 'Fuentes de ingresos',
      eligibilityOptionOne: 'Participación en Programas de Asistencia Pública',    
      eligibilityOptionTwo: 'Ingresos del hogar a la fecha',
      eligibilityOptionOneHint: 'Selecciona este método para demostrar que tú o un integrante de tu hogar participa en algún Programa de Asistencia Pública elegible.',
      eligibilityOptionTwoHint: 'Selecciona este método si deseas demostrar que tu hogar cumple los requisitos de ingresos. Podrías calificar incluso si estás recibiendo beneficios de desempleo.',
      sourceOfIncomeDescription: 'Selecciona todas las fuentes de ingresos de tu hogar.',
      publicAssProgEligibility: 'Elegibilidad para los Programas de Asistencia ',
      publicAssProgEligibilityDiscription: 'Selecciona todos los programas en los que participan los integrantes de tu hogar.',
      incomeEligibilityChart: 'Tabla de elegibilidad de ingresos',
      incomeEligibilityChartDescription: 'Continuar si calificas de acuerdo con la siguiente tabla',
      anualHouseholdIncome: 'Ingresos anuales del hogar',
      totalHouseholdIncome: 'Ingrese el ingreso anual total de su hogar',
      dollorSymbol: '$',
      maximumHouseholdIncome: 'Ingreso máximo del hogar',
      totalCombinedAnnualIncome: 'Ingreso anual total combinado',
      numberInHousehold: 'Numero en casa',
      care: 'CARE',
      fera: 'FERA',
      empty: '',
      errorMessage: 'Por favor elige cualquiera de las opciones para verificar y proceder.',
      stateProgramRecordError: 'Por favor seleccione al menos una opción para continuar.',
      annualHouseholdIncomeErrorMsg: 'Por favor ingrese un ingreso válido',
      recertifyOrEndEnroll: 'Recertifica o cancela tu inscripción',
      recertifyOrEndEnrollDiscription: 'Nuestros registros indican que te inscribiste anteriormente. Selecciona lo que deseas hacer.'

    },
    ko: {
      eligibility: '적임',
      eligibilitySectionDescription: '귀하의 가구가 CARE 또는 FERA 자격을 얻는 방법에는 두 가지가 있습니다. 사용할 방법을 선택하십시오.',
      eligibilityOptionOne: '공공 보조 프로그램에 참여하십시오.',
      eligibilityOptionTwo: '오늘 현재 가구 소득',
      eligibilityOptionOneHint: '고객님 또는 고객님의 집에 있는 누군가가 자격이 되는 공공 보조 프로그램에 참여하고 있는 경우에는 이 방법을 선택하세요',
      eligibilityOptionTwoHint: '고객님의 가구가 소득 요건을 충족하고 있음을 증명하려면 이 방법을 선택하세요. 실업 수당을 받고 있는 경우에도, 자격이 있을 수 있습니다',
      sourceOfIncome: '소득원',
      sourceOfIncomeDescription: '가구 소득의 모든 출처를 선택하세요.',
      incomeEligibilityChart: '소득 자격 표',
      incomeEligibilityChartDescription: '아래 차트에 따라 자격을 취득하면 계속 진행하십시오.',
      totalHouseholdIncome: '총 연간 가계 소득을 입력하세요.',
      maximumHouseholdIncome: '최대 가구 소득',
      numberInHousehold: '세대수',
      totalCombinedAnnualIncome: '합계 된 연간 소득',
      publicAssProgEligibility: '공공 지원 프로그램 자격',
      publicAssProgEligibilityDiscription: '가구 구성원이 참여하는 모든 프로그램을 선택하십시오.',
      recertifyOrEndEnroll: '재 등록 또는 등록 종료',
      recertifyOrEndEnrollDiscription: '저희 기록은 귀하가 이전에 등록했음을 나타냅니다. 원하는 것을 선택하십시오.',
      stateProgramRecordError: '계속하려면 적어도 하나 이상의 옵션을 선택하십시오.',
      errorMessage: '인증 양식의 오른쪽 상단 모서리.',
    },
    vi: {
      eligibility: 'Đủ điều kiện',
      eligibilitySectionDescription: 'Có hai cách gia đình bạn có thể đủ điều kiện để CHĂM SÓC hoặc FERA. Chọn phương thức bạn muốn sử dụng.',
      eligibilityOptionOne: 'Tham gia chương trình trợ giúp công cộng',
      eligibilityOptionTwo: 'Lợi Tức Gia Đình tính tại thời điểm Hôm Nay',
      eligibilityOptionOneHint: 'Chọn phương pháp này để chứng tỏ quý vị hoặc một người trong gia đình tham gia vào các chương trình hỗ trợ công hội đủ điều kiện.',
      eligibilityOptionTwoHint: 'Chọn phương pháp này nếu muốn chứng tỏ gia đình quý vị đáp ứng yêu cầu về lợi tức. Ngay cả khi quý vị đang nhận tiền thất nghiệp, quý vị vẫn có thể hội đủ điều kiện',
      incomeEligibilityChart: 'Biểu đồ đủ điều kiện thu nhập',
      incomeEligibilityChartDescription: 'Tiếp tục nếu bạn đủ điều kiện theo biểu đồ dưới đây',
      sourceOfIncome: 'Nguồn Lợi Tức',
      sourceOfIncomeDescription: 'Chọn tất cả các nguồn lợi tức của gia đình quý vị.',
      maximumHouseholdIncome: 'Thu nhập hộ gia đình tối đa',
      numberInHousehold: 'Số hộ gia đình',
      totalCombinedAnnualIncome: 'Tổng thu nhập hàng năm kết hợp',
      totalHouseholdIncome: 'Nhập vào tổng lợi tức hàng năm của gia đình.',
      publicAssProgEligibility: 'Chương trình Hỗ trợ Công cộng Đủ điều kiện',
      publicAssProgEligibilityDiscription: 'Chọn tất cả các chương trình mà các thành viên trong gia đình bạn tham gia ',
      recertifyOrEndEnroll: 'Xác nhận lại hoặc kết thúc tuyển sinh',
      recertifyOrEndEnrollDiscription: 'Hồ sơ của chúng tôi cho thấy bạn đã đăng ký trước đó. Vui lòng chọn những gì bạn muốn làm',
      stateProgramRecordError: 'Vui lòng chọn ít nhất một tùy chọn để tiến hành',
      errorMessage: 'góc trên bên phải của Mẫu chứng nhận.',
    }
  },
  common: []
};
